var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.857 17.5847C16.7202 17.3641 18.5509 16.9244 20.311 16.2747C18.8204 14.6235 17.9967 12.4772 18 10.2527V9.50269C18 7.91139 17.3679 6.38526 16.2427 5.26005C15.1174 4.13483 13.5913 3.50269 12 3.50269C10.4087 3.50269 8.8826 4.13483 7.75738 5.26005C6.63216 6.38526 6.00002 7.91139 6.00002 9.50269V10.2527C6.00304 12.4773 5.17901 14.6236 3.68802 16.2747C5.42102 16.9147 7.24802 17.3597 9.14302 17.5847M14.857 17.5847C12.959 17.8098 11.041 17.8098 9.14302 17.5847M14.857 17.5847C15.0011 18.0345 15.037 18.5121 14.9616 18.9784C14.8863 19.4447 14.7019 19.8867 14.4234 20.2683C14.145 20.6498 13.7803 20.9603 13.3592 21.1743C12.9381 21.3883 12.4724 21.4999 12 21.4999C11.5276 21.4999 11.0619 21.3883 10.6408 21.1743C10.2197 20.9603 9.85509 20.6498 9.57664 20.2683C9.29819 19.8867 9.11379 19.4447 9.03844 18.9784C8.96309 18.5121 8.99892 18.0345 9.14302 17.5847M3.12402 8.00269C3.40599 6.32765 4.15782 4.76713 5.29202 3.50269M18.708 3.50269C19.8422 4.76713 20.5941 6.32765 20.876 8.00269",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.dc399583eedffe6dc659047f94e23a75.svg";
export { ForwardRef as ReactComponent };